import { getCookie } from 'utils/cookies';

// 특정 url에서 saveLanguage 보다 파라미터로 던지는 locale값의 우선순위를 더 높게 필요로 할때, URL_PATH에 추가
const URL_PATH = ['/signup', '/find-password', '/service-desk'];

const getLang = key => {
  const cookie = getCookie(key);
  if (cookie.includes('zh_TW')) {
    return cookie.substring(3, 5).toLowerCase();
  }
  return cookie.substring(0, 2);
};

export default {
  name: 'customLangCookies',
  lookup(options) {
    const queryString = new URLSearchParams(location.search);
    const locale = queryString.get('locale') || null;
    const isFind = URL_PATH.find(url => window.location.href.indexOf(url) >= 0);
    if (locale && isFind?.length > 0) {
      return locale;
    }
    return getLang(options.lookupCustomLangCookies);
  },

  cacheUserLanguage(lng, options) {
    // options -> are passed in options
    // lng -> current language, will be called after init and on changeLanguage
    // store it
  },
};
